import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';
import { sto } from '../../../../Context/InshData';
import { FormControlLabel } from '@material-ui/core';
import { SaleCheckbox } from '../../../../St/comps/UseStyle';
import { useTranslation } from "react-i18next";
import { restrictStates } from '../../../../services/restrictionService';


export default function RestrictionHead(props) {

    const {
        paramsAuto,
        params,
        onChange,
        onChangeAuto,
        AutoOptions,
        manualRest,
        setManualRest,
        repeatNotes,
        setRepeatNotes,
        IsOpen
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();
    const { t } = useTranslation(["forms", "translation"]);

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={paramsAuto.branch}
                        onChange={(event, newValue) => {
                            onChangeAuto("branch", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions?.Branches}
                        disabled={sto.User_typei == 1 ? false : true}
                        disableClearable={true}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="user"
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateT"
                        label="رقم الفيد"
                        type="number"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="doc_no2" value={params.doc_no2}
                        onChange={onChange("doc_no2")} />
                </Grid>

                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="datef"
                        label="تاريخ القيد "
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="date" format="YYYY-MM-DD"
                        name="date" value={params.date}
                        onChange={onChange("date")} />
                </Grid>
                {IsOpen ?
                    (
                        <>
                            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={clasTF}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    value={paramsAuto.state}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("state", newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={restrictStates}
                                    disableClearable={true}
                                    style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.label
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            id="user"
                                            {...params}
                                            label={"حالة القيد"}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                        />
                                    )}
                                />

                            </Grid>
                        </>
                    ) :
                    (
                        <>
                            <Grid item lg={2} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                <FormControlLabel
                                    id="showPaid"
                                    value="addProfSalary"
                                    name="showPaid"
                                    className={claslbl.clor}
                                    control={
                                        <SaleCheckbox
                                            checked={manualRest}
                                            onChange={(e) => {
                                                setManualRest(e.target.checked);
                                            }}
                                            color={"#f18584"}
                                        />
                                    }
                                    label="قيد يدوي"
                                    labelPlacement="end"
                                />
                            </Grid>

                            <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="dateT"
                                    label=""
                                    type="number"
                                    className={clasTF.rootCust}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    disabled={!manualRest}
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                    name="rest_cycle_no" value={params.rest_cycle_no}
                                    onChange={onChange("rest_cycle_no")} />
                            </Grid>

                            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={clasTF}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    value={paramsAuto.book_id}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("book_id", newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={AutoOptions.AccountBooks}
                                    disableClearable={true}
                                    style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            id="user"
                                            {...params}
                                            label="نوع الدفتر"
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                        />
                                    )}
                                />

                            </Grid>
                        </>
                    )
                }



                <Grid item lg={4} md={4} sm={6} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateT"
                        label={t("note")}
                        type="text"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="notes" value={params.notes}
                        onChange={onChange("notes")} />
                </Grid>

                <Grid item lg={2} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <FormControlLabel
                        id="showPaid"
                        value="addProfSalary"
                        name="showPaid"
                        className={claslbl.clor}
                        control={
                            <SaleCheckbox
                                checked={repeatNotes}
                                onChange={(e) => {
                                    setRepeatNotes(e.target.checked);
                                }}
                                color={"#f18584"}
                            />
                        }
                        label={"تكرار البيان " + " " + "اضغط مفتاح" + " " + "shift"}
                        labelPlacement="end"
                    />
                </Grid>

            </Grid>

        </React.Fragment>

    );

}